import uiAccreditationVoucher from './control/accreditation-voucher'

export {
    uiAccreditationVoucher
}